<div [formGroup]="formularz">
    <label class="c-label">
      <span class="c-label__title" [class.text-danger]="formularz?.get('materialWykonczenia')?.errors && formularz?.get('materialWykonczenia')?.touched">Materiał wykończenia</span>
        <shared-select id='materialWykonczenia' formControlName="materialWykonczenia"
                       (click)="formularz?.get('materialWykonczenia')?.markAsTouched()"
                       [domyslnyWiersz]="'wybierz'"
                       [list]="konwertujMaterialyWykonczenia(rodzajeMaterialowWykonczenia)"
        ></shared-select>
      <span *ngIf="formularz?.get('materialWykonczenia')?.errors && formularz?.get('materialWykonczenia')?.touched"
            class="c-label__title text-danger u-margin-right-tiny">Ta informacja jest obowiązkowa</span>
    </label>
</div>
